import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { InView } from 'react-intersection-observer';

import TeamMembersList from 'components/teams/TeamMembersList';

export default function TeamsSidePanelMembersTab({
  canLoadMoreTeamMembers,
  isFetchingTeamMembers,
  onLoadMoreTeamMembers,
  teamMembers,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'teams.TeamsSidePanelMembersTab',
  });

  const { t: i18nTTeams } = useTranslation('common', {
    keyPrefix: 'teams',
  });

  return (
    <div key='personnelTab' label='personnel'>
      {teamMembers.loaded && teamMembers.collection.length === 0 ?
        <li className='block-list__item tw-border-grey-100'>
          <div className='block-list__item--flex-container'>
            <div className='block-list__item--align-center'>
              <span>{i18nT('emptyState')}</span>
            </div>
          </div>
        </li>
      : <>
          <TeamMembersList teamMembers={teamMembers} />
          {canLoadMoreTeamMembers && (
            <InView as='div' onChange={onLoadMoreTeamMembers} />
          )}
          {isFetchingTeamMembers && (
            <span className='block-list__item tw-border-grey-100'>
              <div className='block-list__item--flex-container'>
                <div className='block-list__item--align-center'>
                  <span>{i18nTTeams('loadingMembers')}</span>
                </div>
              </div>
            </span>
          )}
        </>
      }
    </div>
  );
}

TeamsSidePanelMembersTab.propTypes = {
  teamMembers: PropTypes.object.isRequired,
  canLoadMoreTeamMembers: PropTypes.bool.isRequired,
  onLoadMoreTeamMembers: PropTypes.func.isRequired,
  isFetchingTeamMembers: PropTypes.bool.isRequired,
};
